module.exports = __webpack_public_path__ + "img/AT0000002431086.6cbf4bc2.png";